import type { FaireProductEntity } from "../../entity_types/product";

export const p_37vfgdwkv8: FaireProductEntity = {
  token: "p_37vfgdwkv8",
  type: "product",
  name: "Aquanet Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/56ce20212d3c15aca156f7ab102a6b1a96e58bb25ad93f2cb07eb19f88aa3abd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f1c6b2b6f91537fc3603080f4722f3896ca4a8ff9ef6719dd2b7dd60dabe6fd.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:27.330Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
